export default __webpack_public_path__ + "static/media/henriklogo.349f5cfd.png";